import { use_slice_generation } from '@/hooks/store/use_slices';
import { ENUM__i18n_namespace } from '@/services/i18n/ENUM__i18n_namespace';
import { useTranslation } from 'react-i18next';
import { GRID2D__master } from '../_base/grid2d/views/GRID2D__master';
import { LAYOUT_COLUMN__left } from '../_base/layout_base/LAYOUT_COLUMN__left';
import { FOOTER__master } from '../_base/layout_footer/FOOTER__master';
import { HEADER__master } from '../_base/layout_header/HEADER__master';
import { U_SIDEBAR__user_tasks_list } from './user_tasks_list/U_SIDEBAR__user_tasks_list';

export function U_PAGE_LAYOUT_DESKTOP__user_task() {
  const { t } = useTranslation(ENUM__i18n_namespace.PAGE_USER_TASKS);

  const { user_task_current } = use_slice_generation(['user_task_current']);

  /*
   * RENDERS
   */

  function render_column_center() {
    if (user_task_current.is_stub()) return null;

    return (
      <div className="flex flex-col flex-1 p-2">
        <GRID2D__master entity_type={user_task_current.type} entity_id={user_task_current._id} />
      </div>
    );
  }

  /*
   * HTML
   */

  return (
    <div className="size-full bg-bar flex flex-col antialiased overflow-hidden">
      <HEADER__master />

      {/* Remaining Space: Scrollable List Area */}
      <main className="flex flex-row flex-1 min-h-0 w-full bg-bar">
        <LAYOUT_COLUMN__left could_be_hidden>
          <U_SIDEBAR__user_tasks_list />
        </LAYOUT_COLUMN__left>

        {render_column_center()}
      </main>

      <FOOTER__master />
    </div>
  );
}
